import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AtributosService {

  constructor(private readonly http: HttpClient) { }

  public getCompaniesAttributes(atributo: string, companyId: number) {
    return this.http.get(`/apiconnect/parameters-vt/system/companies/${companyId}/attributes?attributeCode=${atributo}`);
  }
}
